import { compose } from 'recompose';

const enhancer = compose();

export default enhancer;
